import React from 'react';
import JRoute from 'route/jroute';
import AnimationHeader from 'component/header/animationHeader';
import Footer from 'component/footer/footer_default';
import SideBar from 'component/sideBar';
import MobileFooterMenu from 'component/mobileFooterMenu';

// local 撰寫component時 可在此展示即可

const Layout = props => {
  const { classNames } = props;
  return (
    <div className={classNames}>
      <AnimationHeader />
      <SideBar />
      <JRoute />
      <Footer />
      <MobileFooterMenu />
    </div>
  );
};

export default Layout;
